import InteroperaRepository from "@/repositories/InteroperaRepository";
import makeState from "@/storages/Base/State";
import makeGetters from "@/storages/Base/Getters";
import makeMutations from "@/storages/Base/Mutations";

export default {
    name: 'interopera',
    namespaced: true,
    state: makeState(),
    getters: makeGetters(),
    mutations: makeMutations(),
    actions: {
        async listOne ({ commit, state }, id) {
            commit('setLoading', true)
            await InteroperaRepository.fetch(id).then(response => {
                commit('setCurrent', response.data.data)
            })
            commit('setLoading', false)
        },
        async listAll ({ commit }, params) {
            commit('setLoading', true)
            await InteroperaRepository.fetchAll(params).then(response => {
                commit('setAll', response.data.data.logs)
                commit('setPagination', response.data.data.meta)
            })
            commit('setLoading', false)
        }
    }
}
